import { useSelector } from 'react-redux';

import { selectIsUserAgent, selectUserTariffs } from '../../selectors/user';
import { useApplicationContext } from '../../utils/applicationContext';

export const usePlacementTabProps = () => {
  const { config } = useApplicationContext();
  const isAgent = useSelector(selectIsUserAgent);
  const tariffs = useSelector(selectUserTariffs);

  if (isAgent || isCommercialTariffs(tariffs)) {
    return {
      text: null,
      url: null,
    };
  }

  return {
    text: config.get<string>('placementButtonExperiment.experimentalText'),
    url: config.get<string>('placementButtonExperiment.experimentalURL'),
  };
};

function isCommercialTariffs(tariffs: string[] | null) {
  const NON_COMMERCIAL_TARIFFS = ['none', 'noCommerce'];

  if (!tariffs) {
    return false;
  }

  if (tariffs.some(tariff => !NON_COMMERCIAL_TARIFFS.includes(tariff))) {
    return true;
  }

  return false;
}
